<script>
export default {
  name: "HyperLinkGpsNavisionEquipos",
  functional: true,
  props: {
    row: Object,
    column: String
  },
  render: function (createElement, context) {
    const val = Number(context.props.row[context.props.column]);
    // const MetaMes = context.props.row.MontlyTarget;
    // const VentaMes = context.props.row.Totals;

    let classs = "info";

    const MothValue = function (val) {
      if (val > 0) {
        return val;
      } else {
        return "";
      }
    };

    return createElement(
      "a",
      {
        attrs: {
          name: "",
          href: "#",
          class: classs
        },
        on: {
          click: () => {
            const { row } = context.props;
            context.data.attrs.openDetailGPSNavision(row);
          }
        }
      },
      MothValue(val)
    );
  }
};
</script>
<style scoped>
.red {
  color: red;
}
.green {
  color: green;
}
.golden {
  color: goldenrod;
}
</style>
